import React from 'react';
import DefaultLayout from '../../../layouts/default';
import { DeliveryProvider } from './context/DeliveryContext';
import AllDeliveries from './components/AllDeliveries';
import DeliveryManagementHeader from './components/DeliveryManagementHeader';
import DeliveryPanels from './components/DeliveryPanels';

function DeliveryCheckPage() {
  return (
    <DeliveryProvider>
      <DefaultLayout>
        <DeliveryManagementHeader />
        <AllDeliveries />
        <DeliveryPanels />
      </DefaultLayout>
    </DeliveryProvider>
  );
}

export default DeliveryCheckPage;